





























































































import { BasicProductV2 as BasicProduct } from '@master/model/kyc-form/product/BasicProductV2'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import TheInsuranceProductModal from '@core/components/basicRecommendation/TheInsuranceProductModal.vue'
import TheInvestmentProductModal from '@core/components/basicRecommendation/TheInvestmentProductModal.vue'
import { inject } from 'inversify-props'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'
import { IRiskRatingService } from '@master/services/IRiskRatingService'
import AppDialog from '@core/components/AppDialog.vue'
import { ProductList } from '@core/pages/adminProductList/model/ProductList'
import { CompanyDetailsMetaList } from '@core/pages/companyDetails/model/CompanyDetailsMetaList'
import { cloneDeep } from 'lodash/fp'
import { isEqual, keys, omit, pick } from 'lodash'
import TheProductCard, { CardStructure } from '@core/components/basicRecommendation/TheProductCard.vue'
import { IPrioritiesStructure } from '@master/model/kyc-form/need-analysis/IPrioritiesStructure'
import KYCClient from '@company-common/model/kyc-form/KYCClient'
import { IProjectInfo } from '@master/config/IProjectInfo'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    TheInsuranceProductModal,
    TheInvestmentProductModal,
    AppDialog,
    TheProductCard
  }
})
export default class TheProductRecommendations extends Vue {
   @kycFormStore.State
  private kycForm!: KYCForm;

 @kycFormStore.State
  private productList: ProductList

  @kycFormStore.State
  private cdMetaList: CompanyDetailsMetaList

  @kycFormStore.Action
  private fetchCompanyDetails!: () => void

   @kycFormStore.Action
  private fetchRecommendedAllProducts!: () => void

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  @inject()
  private riskRatingService: IRiskRatingService

  @inject()
  private ThePrioritiesNeeds: IPrioritiesStructure<KYCClient>

  @inject()
  private projectInfo: IProjectInfo

  private isModalVisible = false;
  private isModalInsuranceVisible = false;
  private isModalInvestmentVisible = false;

  private newBasicProduct: BasicProduct = null
  private isEdit = false;
  private editingIndex = null;
  private savingInsurance = false
  private savingInvestment = false
 private isAddNewProduct = false

 get recommendations () {
   return this.kycForm.recommendations
 }

 get nameList () {
   return this.kycForm.getLifeAssured()
 }

 get unCategorizedProductList () {
   const array = this.recommendations.validBasicProduct.filter(product => !product.type)
   return array.map(product => {
     return {
       ...product,
       priorityName: this.getPriorityFriendlyName(product.priority),
       ownerName: this.getOwnerName(product.clientIndex)
     }
   })
 }

 get insuranceProductList () {
   return this.recommendations.validBasicProduct.filter(product => product.type === 'insurance')
     .map(product => {
       if (product.riders.length > 0) {
         product.riders.forEach(rider => {
           rider.priorityName = this.getPriorityFriendlyName(rider.priority)
         })
       }
       return {
         ...product,
         priorityName: this.getPriorityFriendlyName(product.priority)
       }
     })
 }

 get investmentProductList () {
   return this.recommendations.validBasicProduct.filter(product => product.type === 'investment')
     .map(product => {
       if (product.investmentFunds.length > 0) {
         product.investmentFunds.forEach(funds => {
           funds.priorityName = this.getPriorityFriendlyName(funds.priority)
         })
       }
       return {
         ...product,
         priorityName: this.getPriorityFriendlyName(product.priority)
       }
     })
 }

 get currencySymbol () {
   const symbol = this.projectInfo.currencyToLabel ?? '$'
   return `(${symbol})`
 }

 get insuranceStructure (): CardStructure {
   return {
     summary: [
       { label: 'Priority Type:', key: 'priorityName' }
     ],
     details: [
       { label: 'Product Type:', key: 'productType' },
       { label: 'Issuer:', key: 'issuer' },
       { label: 'Life Assured 1:', key: 'lifeAssured' },
       { label: 'Life Assured 2:', key: 'lifeAssuredTwo' },
       { label: 'Product Covered Needs:', key: 'productNeedsCovered' },
       { label: `Sum Assured ${this.currencySymbol}:`, key: 'sumAssured', type: 'currency' },
       { label: `Premium Amount ${this.currencySymbol}:`, key: 'premiumAmount', type: 'currency' },
       { label: 'Frequency:', key: 'frequency' },
       { label: 'Product Risk Rating:', key: 'recommendedRiskProfileString' }
     ],
     subList: [
       { label: 'Product Type:', key: 'productType' },
       { label: 'Product Name:', key: 'productName' },
       { label: 'Priority Type:', key: 'priorityName' },
       { label: `Sum Assured ${this.currencySymbol}:`, key: 'sumAssured', type: 'currency' },
       { label: `Premium Amount ${this.currencySymbol}:`, key: 'premiumAmount', type: 'currency' },
       { label: 'Frequency:', key: 'frequency' }
     ]
   }
 }

 get investmentStructure (): CardStructure {
   return {
     summary: [
       { label: 'Product Type:', key: 'productType' },
       { label: 'Issuer:', key: 'issuer' }
     ],
     details: [
     ],
     subList: [
       { label: 'Priority Type:', key: 'priorityName' },
       { label: 'Fund Name:', key: 'productName' },
       { label: 'Type of Transactions:', key: 'transactionType' },
       { label: `Investment Amount ${this.currencySymbol}:`, key: 'sumAssured', type: 'currency' }
     ]
   }
 }

 get uncategorisedProductStructure (): CardStructure {
   return {
     summary: [
       { label: 'Priority Type:', key: 'priorityName' },
       { label: 'Owner:', key: 'ownerName' }
     ],
     details: [
     ],
     subList: [
     ]
   }
 }

 get client1PersonalDetails () {
   return this.kycForm.client1.personalDetails
 }

 get client2PersonalDetails () {
   return this.kycForm.client2.personalDetails
 }

 get priorities () {
   return this.ThePrioritiesNeeds.getFilteredPriorities(this.kycForm)
 }

 getPriorityFriendlyName (priorityId: string) {
   const targetPriority = this.priorities.find(priority => priority.id === priorityId)
   return targetPriority?.name || ''
 }

 openModal () {
   this.resetProduct()
   this.isAddNewProduct = true
   this.isModalVisible = true
 }

 openModalInsurance () {
   this.isModalInsuranceVisible = true
   this.isModalInvestmentVisible = false
   this.isModalVisible = false
 }

 openModalInvestment () {
   this.isModalInsuranceVisible = false
   this.isModalInvestmentVisible = true
   this.isModalVisible = false
 }

 resetProduct () {
   this.newBasicProduct = new BasicProduct(this.riskRatingService)
   this.isEdit = false
   this.editingIndex = null
   this.savingInsurance = false
   this.savingInvestment = false
   this.isAddNewProduct = false
 }

 get ownerOptions () {
   const options = [
     { name: '', value: undefined },
     { name: this.client1PersonalDetails.name, value: 0 }
   ]

   if (this.kycForm.hasClient2) {
     options.push({
       name: this.client2PersonalDetails.name,
       value: 1
     })
   }
   return options
 }

 getOwnerName (clientIndex: number) {
   return this.ownerOptions.find(op => op.value === clientIndex)?.name
 }

 async triggerSaveInsurance () {
   this.savingInsurance = true
 }

 async triggerSaveInvestment () {
   this.savingInvestment = true
 }

 async saveInsurance (event) {
   const { validationPass, insuranceModal } = event
   this.savingInsurance = false
   if (!validationPass) {
     return
   }

   insuranceModal.type = 'insurance'
   // Generate Reference ID
   if (!insuranceModal.referenceId)insuranceModal.referenceId = insuranceModal.randomString(22)

   if (this.isEdit) {
     this.$set(this.kycForm.recommendations.rcmd, this.editingIndex, insuranceModal)
   } else {
     this.kycForm.recommendations.rcmd.push(insuranceModal)
   }

   this.$emit('save')
   this.isModalInsuranceVisible = false
   this.isModalInvestmentVisible = false

   this.resetProduct()
 }

 async saveInvestment (event) {
   const { validationPass, investmentModal } = event
   this.savingInvestment = false
   if (!validationPass) {
     return
   }

   investmentModal.type = 'investment'

   // Generate Reference ID
   if (!investmentModal.referenceId) investmentModal.referenceId = investmentModal.randomString(22)

   // Ensure that all investment funds has the same client index and jointClientIndex
   investmentModal.investmentFunds.map(fund => {
     fund.clientIndex = investmentModal.clientIndex
     fund.jointClientIndex = investmentModal.jointClientIndex
   })

   if (this.isEdit) {
     this.$set(this.kycForm.recommendations.rcmd, this.editingIndex, investmentModal)
   } else {
     this.kycForm.recommendations.rcmd.push(investmentModal)
   }

   this.$emit('save')
   this.isModalInsuranceVisible = false
   this.isModalInvestmentVisible = false

   this.resetProduct()
 }

 editUnCategorisedProduct (event) {
   const { product } = event
   this.isAddNewProduct = false
   this.isEdit = true
   this.newBasicProduct = cloneDeep(product)
   this.isModalVisible = true
   this.editingIndex = this.findIndexOfProduct(product)
 }

 findIndexOfProduct (product) {
   // to remove the proxy so that it can do comparison with the target product
   // this is because cannot compare the proxy to the object
   // and pick the very ori key only for comparison
   const flatRcmd = this.kycForm.recommendations.rcmd.map(prd => {
     return pick(prd, keys(new BasicProduct(this.riskRatingService)))
   })

   // only pick the key that contain in the new BasicProduct, so that it is not affected by the custom key: priorityName, ownerName
   const newProduct = pick(product, keys(new BasicProduct(this.riskRatingService)))

   return flatRcmd.findIndex(_product => isEqual(_product, newProduct))
 }

 editProduct (event) {
   const { product, type } = event
   this.editingIndex = this.findIndexOfProduct(product)

   this.newBasicProduct = cloneDeep(product)

   this.isEdit = true
   if (type === 'insurance') {
     this.isModalInsuranceVisible = true
   } else {
     this.isModalInvestmentVisible = true
   }
 }

 async deleteProduct (event) {
   const { product } = event
   const isConfirm = await this.uiService.confirm.show({
     type: 'warning',
     message: 'Are you sure you want to delete this product?'
   })

   if (isConfirm) {
     const productIndex = this.findIndexOfProduct(product)
     this.kycForm.recommendations.rcmd.splice(productIndex, 1)
     this.$emit('save')
   }
 }

 async created () {
   this.uiService = this.sharedVariable.uiService
   this.newBasicProduct = new BasicProduct(this.riskRatingService)
   await this.fetchCompanyDetails()
   await this.fetchRecommendedAllProducts()
 }
}
